import React, {useRef} from 'react';
import {OverviewProvider} from "../contexts/OverviewContext";
import ErrorHandler from "../../../common/src/errors/ErrorHandler";
import MetricsService from "../../../common/src/services/MetricsService";
import Constants from "../../../common/src/Constants";
import OverviewComponent from "./OverviewComponent";
import keys from '../utils/locResourcesKeys';
import {LocResourcesProvider} from '../../../common/src/contexts/LocResourcesContext';
import {ViewType} from '../types'

interface OverviewProps {
    siteDomain: string,
    siteId: number,
    lang: string,
    view: ViewType
}

const Overview = ({siteDomain, siteId, lang, view}: OverviewProps): JSX.Element => {
    const metricServiceInstanceRef = useRef<MetricsService>(
        new MetricsService({
            initTimestamp: Date.now(),
            componentName: Constants.COMPONENT_NAME.OVERVIEW,
            siteDomain
        }).renderInit(),
    );

    return (
        <ErrorHandler
            metricsService={metricServiceInstanceRef.current}>
            <LocResourcesProvider metricsService={metricServiceInstanceRef.current} lang={lang}
                                  keys={keys} siteId={siteId}>
                <OverviewProvider
                    view={view}
                    siteId={siteId}
                    siteDomain={siteDomain}
                    lang={lang}
                    metricsService={metricServiceInstanceRef.current}>
                    <OverviewComponent view={view} siteDomain={siteDomain}/>
                </OverviewProvider>
            </LocResourcesProvider>
        </ErrorHandler>
    )
}

export default React.memo(Overview)
